import React from 'react';
import { Link } from 'react-router-dom';

import './app_logo.scss';

export default function AppLogo() {
  return (
    <Link
      className="app-logo"
      to="/"
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/app_logo/app_logo.jsx